import React from "react";
import { IconButton, Image } from "@chakra-ui/react";
import downloadBtn from "../../assets/waveflowmain/downloadBtnBlue.png";

const DownloadJsonFileList = ({ dataDownload }) => {
  const downloadJSON = () => {
    const data = dataDownload;

    const jsonString = `data:text/json;charset=utf-8,${encodeURIComponent(
      JSON.stringify(data, null, 2)
    )}`;

    const link = document.createElement("a");
    link.href = jsonString;
    link.download =
      `${dataDownload?.client || dataDownload?.name}.json` || "data.json";
    link.click();
  };

  return (
    <IconButton
      onClick={downloadJSON}
      icon={<Image src={downloadBtn} alt="download" width={"15px"} />}
      size="sm"
      colorScheme="red"
      variant="ghost"
      aria-label="Delete item"
      p={0}
      m={0}
    />
  );
};

export default DownloadJsonFileList;
